import { Select } from 'antd';

export const ScreenBrightnesses = [...Array(10).keys()].reduce((prev, curr) => {
  const v = curr + 1;
  prev[v] = {
    key: v,
    label: `${v}`,
  };
  return prev;
}, {});

function SelectScreenBrightness({ value, onChange, ...other }) {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder="Select a screen brightness level"
      allowClear
      {...other}
    >
      {Object.values(ScreenBrightnesses).map((v) => (
        <Select.Option key={v.key} value={v.key}>
          {v.label}
        </Select.Option>
      ))}
    </Select>
  );
}

export default SelectScreenBrightness;
